var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* This stylesheet generated by Transfonter (https://transfonter.org) on August 29, 2017 10:35 AM */\r\n\r\n@font-face {\r\n\tfont-family: 'Byom Icons';\r\n\tsrc: url(" + escape(require("./ByomIcons.eot")) + ");\r\n\tsrc: url(" + escape(require("./ByomIcons.eot")) + "?#iefix) format('embedded-opentype'),\r\n\t\turl(" + escape(require("./ByomIcons.woff")) + ") format('woff'),\r\n\t\turl(" + escape(require("./ByomIcons.ttf")) + ") format('truetype');\r\n\tfont-weight: normal;\r\n\tfont-style: normal;\r\n}\r\n", ""]);

// exports
